class UserError extends Error {

}

export {
  UserError
}
